import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import config from "./config.json";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import SweetAlertIcons from "vue-sweetalert-icons";

Vue.config.productionTip = false;
Vue.use(SweetAlertIcons);
Vue.component("sweetalert-icon", SweetAlertIcons);
axios.get("/config.json").then((res) => {
  Vue.prototype.$config = res.data;
  new Vue({
    router,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
